import { createSlice } from '@reduxjs/toolkit'
import { EMPTY_VALUE, SPORT_TABS, BUTTON_SELECTION } from '../common/Foundation';

export const initialState = {
  selectedSportTab: SPORT_TABS.SPORTS,
  previousSelectedSportTab: SPORT_TABS.SPORTS,
  selectedButton: BUTTON_SELECTION.ALL_EVENTS,
  selectedMarketTab: EMPTY_VALUE,
  selectedMarketId: EMPTY_VALUE,
  selectedHorseRacingMarketTab: EMPTY_VALUE,
  selectedHorseRacingMarketId: EMPTY_VALUE,
  selectedSportId: EMPTY_VALUE,
  selectedVirtualSportId: EMPTY_VALUE,
  selectedHighlightId: EMPTY_VALUE,
  selectedEsportGame: EMPTY_VALUE,
  isReUpdateNoLiveMenu: false,
  numberOfPendingBets: 0,
  isSelectEsportLiveTab: false,
  isOddsLoading: false,
  firstSportId: EMPTY_VALUE,
  selectedTabFromStatsPage: EMPTY_VALUE,
  isSelectFromDropdown: EMPTY_VALUE,
}

export const SidebarSelectedDataSlice = createSlice({
  name: 'SidebarSelectedDataSlice',
  initialState,
  reducers: {
    changeButton: (state, {payload}) => {
      state.selectedButton = payload
    },
    changeSportTab: (state, {payload}) => {
      state.selectedSportTab = payload === SPORT_TABS.ESPORTS && window.env.leftMenuRemoveEsportsTab ?
        SPORT_TABS.SPORTS :
        payload
    },
    changePreviousSelectedSportTab: (state, {payload}) => {
      state.previousSelectedSportTab = payload
    },
    changeMarketTab: (state, {payload}) => {
      state.selectedMarketTab = payload
    },
    changeMarketId: (state, {payload}) => {
      state.selectedMarketId = payload
    },
    resetMarketId: state => {
      state.selectedMarketId = EMPTY_VALUE
    },
    changeHorseRacingMarketTab: (state, {payload}) => {
      state.selectedHorseRacingMarketTab = payload
    },
    changeHorseRacingMarketId: (state, {payload}) => {
      state.selectedHorseRacingMarketId = payload
    },
    resetHorseRacingMarketId: state => {
      state.selectedHorseRacingMarketId = EMPTY_VALUE
    },
    changeSportId: (state, {payload}) => {
      state.selectedSportId = payload
    },
    resetSelectedHighLightId: state => {
      state.selectedHighLightId = EMPTY_VALUE
    },
    changeSelectedHighLightId: (state, {payload}) => {
      state.selectedHighLightId = payload
    },
    changeEsportGame: (state, {payload}) => {
      state.selectedEsportGame = payload
    },
    changeSelectedTabFromStatsPage: (state, {payload}) => {
      state.selectedTabFromStatsPage = payload
    },
    resetEsportGame: state => {
      state.selectedEsportGame = EMPTY_VALUE
    },
    resetMarketTab: state => {
      state.selectedMarketTab = EMPTY_VALUE
    },
    changeVirtualSportId: (state, {payload}) => {
      state.selectedVirtualSportId = payload
    },
    enableReUpdateNoLiveMenu: state => {
      state.isReUpdateNoLiveMenu = true
    },
    disableReUpdateNoLiveMenu: state => {
      state.isReUpdateNoLiveMenu = false
    },
    updateNumberOfPendingBets: (state, {payload}) => {
      state.numberOfPendingBets = payload;
    },
    resetVirtualSportId: (state) => {
      state.selectedVirtualSportId = EMPTY_VALUE
    },
    resetSportTab: state => {
      if (state.selectedSportTab === SPORT_TABS.VIRTUAL_SPORTS) {
        state.selectedSportTab = SPORT_TABS.SPORTS;
        state.selectedVirtualSportId = EMPTY_VALUE;
      }
    },
    updateSelectEsportLiveTab: (state, {payload}) => {
      state.isSelectEsportLiveTab = payload
    },
    updateIsOddsLoading: (state, {payload})=>{
      state.isOddsLoading = payload;
    },
    updateFirstSportId: (state, {payload}) => {
      state.firstSportId = payload
    },
    setIsSelectFromDropdown: (state, {payload}) => {
      state.isSelectFromDropdown = payload
    }
  }
})

export const {
  changeButton,
  changeSportTab,
  changePreviousSelectedSportTab,
  changeMarketTab,
  changeSportId,
  changeEsportGame,
  changeVirtualSportId,
  changeSelectedHighLightId,
  enableReUpdateNoLiveMenu,
  disableReUpdateNoLiveMenu,
  resetEsportGame,
  resetMarketTab,
  changeMarketId,
  resetMarketId,
  changeHorseRacingMarketTab,
  changeHorseRacingMarketId,
  resetHorseRacingMarketId,
  resetSelectedHighLightId,
  resetSportTab,
  updateNumberOfPendingBets,
  resetVirtualSportId,
  updateSelectEsportLiveTab,
  updateIsOddsLoading,
  changeSelectedTabFromStatsPage,
  updateFirstSportId,
  setIsSelectFromDropdown
} = SidebarSelectedDataSlice.actions

export const sidebarSelectedDataSelector = state => state.SidebarSelectedDataSlice
export default SidebarSelectedDataSlice.reducer


// WEBPACK FOOTER //
// ./src/app/slices/SidebarSelectedDataSlice.js